import React from 'react'

const Title = ({title}) => {
  return (
    <>
    <div className='bg-black fixed w-full z-10'>
    <div className='max-w-containerSm md:max-w-container h-[70px] md:h-[100px] mx-auto'>
   <p className='mt-[92px] text-[24px] md:text-[40px] font-bold md:font-semibold text-white font-barlow'>{title}</p>
    </div>
    </div>
    </>
  )
}

export default Title